import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  background: var(--bg-main);
  color: var(--text-primary);
  text-align: center;
`;

const Title = styled.h1`
  font-size: 6rem;
  margin-bottom: 0;
  color: var(--primary-color, #6366f1);
`;

const Subtitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  font-size: 1.1rem;
  color: grey;
  margin-bottom: 2rem;
`;

const HomeButton = styled.button`
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  border: none;
  background: var(--primary-color, #6366f1);
  color: white;
  font-size: 1rem;
  cursor: pointer;
  &:hover {
    opacity: 0.9;
  }
`;

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Container>
      <Title>404</Title>
      <Subtitle>Page Not Found</Subtitle>
      <Message>The page you're looking for doesn't exist or has been moved.</Message>
      <HomeButton onClick={() => navigate('/')}>Go to Home</HomeButton>
    </Container>
  );
}
